module.exports = __webpack_public_path__ + "img/English.e543c9b7.jpg";